var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00457 11.55C9.25308 11.3015 9.65601 11.3015 9.90452 11.55L11.3636 13.0091V9.45455C11.3636 9.10309 11.6485 8.81818 12 8.81818C12.3515 8.81818 12.6364 9.10309 12.6364 9.45455V13.0091L14.0955 11.55C14.344 11.3015 14.7469 11.3015 14.9954 11.55C15.2439 11.7985 15.2439 12.2015 14.9954 12.45L12.4504 14.995C12.4489 14.9965 12.4474 14.998 12.4458 14.9996C12.3314 15.1119 12.1748 15.1813 12.0019 15.1818L12 15.1818L11.9981 15.1818C11.9125 15.1816 11.8309 15.1644 11.7564 15.1335C11.6831 15.1032 11.6142 15.0585 11.5542 14.9996C11.5526 14.998 11.5511 14.9965 11.5496 14.995L9.00457 12.45C8.75605 12.2015 8.75605 11.7985 9.00457 11.55Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12ZM12 6.27273C8.83691 6.27273 6.27273 8.83691 6.27273 12C6.27273 15.1631 8.83691 17.7273 12 17.7273C15.1631 17.7273 17.7273 15.1631 17.7273 12C17.7273 8.83691 15.1631 6.27273 12 6.27273Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownCircle);
export default __webpack_public_path__ + "static/media/icon-arrow-down-circle.249b3ffdbf91923a7849d1a1e3625540.svg";
export { ForwardRef as ReactComponent };